"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YoutubeUploader = void 0;
const YoutubeUploader_1 = require("./YoutubeUploader");
class YoutubeUploader {
    constructor({ theme }) {
        this.theme = theme;
    }
    createYoutubeButton(container, onUpload, closeDashboard) {
        var _a;
        if (container.querySelector('.uppy-youtube-button'))
            return;
        const div = document.createElement('div');
        const button = document.createElement('button');
        button.innerHTML =
            '<svg width="32", height="32", viewBox="0 0 32 32"><use xlink:href="#youtube"></use></svg><div class="uppy-DashboardTab-name">Youtube</div>';
        button.setAttribute('class', 'uppy-u-reset uppy-c-btn uppy-DashboardTab-btn');
        button.onclick = () => {
            const app = new YoutubeUploader_1.YoutubeUploaderApp(onUpload, {
                theme: this.theme,
            });
            app.mountApp();
            closeDashboard();
        };
        div.classList.add('uppy-DashboardTab');
        div.classList.add('uppy-youtube-button');
        div.append(button);
        (_a = container.querySelector('span[role=presentation]')) === null || _a === void 0 ? void 0 : _a.append(div);
    }
}
exports.YoutubeUploader = YoutubeUploader;
//# sourceMappingURL=uploader.youtube.js.map